/**
 * What the free-trial form says about a field the browser finds invalid, in place of the browser's
 * own pop-up, which names no field and disappears. Pure, so it can be tested without a browser.
 */

/** The parts of `ValidityState` the form's fields can break. */
export type FieldValidity = Pick<
  ValidityState,
  'valid' | 'valueMissing' | 'patternMismatch' | 'tooShort' | 'typeMismatch'
>;

const MISSING: Record<string, string> = {
  businessName: 'Enter your business name.',
  city: 'Enter your city.',
  state: 'Choose your state.',
  contactName: 'Enter your name.',
  mobile: 'Enter your mobile number.',
  email: 'Enter your email address.',
  username: 'Choose a username.',
  password: 'Choose a password.',
  consent: 'Please agree to the terms and the privacy policy to continue.',
};

const WRONG: Record<string, string> = {
  gstin: 'A GSTIN has 15 letters and digits. Leave it empty if you are not registered.',
  mobile: 'Enter a 10-digit Indian mobile number, starting with 6, 7, 8 or 9.',
  email: 'Enter a complete email address, like name@example.com.',
  username: 'Use 3 to 60 letters, digits, dots, dashes, underscores or @, with no spaces.',
  password: 'Use at least 8 characters.',
};

/** The sentence to show under a field, or null when it is fine. */
export function fieldProblem(name: string, validity: FieldValidity): string | null {
  if (validity.valid) return null;
  if (validity.valueMissing) return MISSING[name] ?? 'This field is needed.';
  return WRONG[name] ?? 'Check this field.';
}
